import { InvisibleButton } from '@/widgets/components/invisible-button';
import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled(InvisibleButton)`
  height: 100px;
  width: 360px;
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: ${(props) => (props.active ? '#f0f5ff' : 'inherit')};
  opacity: ${(props) => (props.opacity ? 0.3 : 1)};
  cursor: ${(props) => (props.opacity ? 'default' : 'pointer')};
`;

const DescriptionWrapper = styled.div`
  height: 100%;
  margin-left: 16px;
  align-items: unset;
`;

const Title = styled.div`
  ::before {
    content: '${(props) => props.text}';
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1;
    display: flex;
    text-align: left;
  }
`;

const Description = styled.div`
  ::before {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    text-align: left;
    content: '${(props) => props.text}';
  }
`;

export function AddChartItem(props) {
  const [isActive, setIsActive] = useState(false);

  function handleItemClicked(itemId, isNotClickable) {
    if (!isNotClickable && itemId !== '') {
      props.onClick(itemId, isActive);
      setIsActive(!isActive);
    }
  }

  return (
    <Wrapper
      opacity={+props.opacity}
      active={isActive}
      id={props.id}
      onClick={(event) => {
        event.persist();
        handleItemClicked(event.target.id, props.opacity);
      }}
    >
      <div style={{ paddingRight: 10 }}>
        <props.Thumbnail id={props.id} />
      </div>
      <DescriptionWrapper id={props.id}>
        <Title id={props.id} text={props.title} />
        <Description id={props.id} text={props.description} />
      </DescriptionWrapper>
    </Wrapper>
  );
}
